import "./loader.scss";

export const ShimmerLoader = () => {
  return (
    <>
      <div className="instagram-loader">
        <div className="text-section">
          <div className="text-line shimmer"></div>
          <div className="text-line shimmer"></div>
          <div className="text-line shimmer short"></div>
        </div>
      </div>{" "}
    </>
  );
};
export const ShimmerLoaderOneLine = () => {
  return (
    <>
      <div   className="instagram-loader">
        <div className="text-section">
          <div className="text-line shimmer"></div>
        </div>
      </div>{" "}
    </>
  );
};
export const ShimmerOfCardLoader = () => {
  return (
    <>
    <div  style={{justifyContent:"start",padding:"0px"}} className="instagram-loader">
 <div  style={{width:"295px", height:"10px"}} className="shimmer-white"></div>
    </div>
   
    </>
  )
}
export const ShimmerOfprofileLoader = () => {
  return (
    <>
      <div className="instagram-loader">
        <div className="profile-section">
          <div className="profile-pic shimmer"></div>
          <div className="profile-details">
            <div className="profile-name shimmer"></div>
            <div className="profile-meta shimmer"></div>
          </div>
        </div>
      </div>{" "}
    </>
  );
};

export const ShimmerOfprofileCardLoader = () => {
  return (
    <>
      <div className="instagram-loader">
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
          className="profile-section"
        >
          <div
            style={{ borderRadius: "50%" }}
            className="profile-pic shimmer"
          ></div>
          <div
            style={{
              margin: "auto",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
            className="profile-details"
          >
            <div className="profile-name shimmer"></div>
            <div className="profile-meta shimmer"></div>
          </div>
        </div>
        <div style={{ width: "100%" }} className="text-section">
          <div className="text-line shimmer-white"></div>
          <div className="text-line shimmer-white"></div>
          <div className="text-line shimmer-white short"></div>
        </div>
      </div>{" "}
    </>
  );
};
export const ShimmerLoaderwhite = ({maxWidth}:any) => {
  return (
    <>
      <div style={{maxWidth:`${maxWidth}`}}  className="instagram-loader">
        <div className="text-section">
          <div className="text-line shimmer-white"></div>
          <div className="text-line shimmer-white"></div>
          <div className="text-line shimmer-white short"></div>
        </div>
      </div>{" "}
    </>
  );
};
export const ShimmerLoaderwhiteOneLine = ({margins}:{
  margins?:boolean
} ) => {
  return (
    <>
      <div style={{ margin:`${margins ? "0px 0px": "10px auto"}` }} className="instagram-loader">
        <div className="text-section">
          <div className="text-line shimmer-white"></div>
        </div>
      </div>{" "}
    </>
  );
};
